import { FunctionComponent, PropsWithChildren, useMemo } from 'react';

import { WithOptionsModel } from '../../../../../../../../shared/components/with-options/models/with-options.model';
import { withOptions } from '../../../../../../../../shared/components/with-options/with-options';
import { getEcusByModel } from '../../../../../../../../shared/thunks/get-ecus-by-model/get-ecus-by-model.thunk';
import { castTo } from '../../../../../../../shared/utils/cast-to';
import { mapAttendedECUToItemLabelModel } from '../../../../../../utils/mapping/mapping.util';
import { FirmwareFilterProps } from '../../../../types/firmware-filter-props.type';

export const withEcusOptions = (
  Component: FunctionComponent<FirmwareFilterProps & WithOptionsModel>
): FunctionComponent<FirmwareFilterProps & WithOptionsModel> => {
  return (props: PropsWithChildren<FirmwareFilterProps & WithOptionsModel>) => {
    const selectedModels = props?.firmwareSelectFilters?.modelIds;
    const modelIds = selectedModels
      ? castTo<number[]>(selectedModels)
      : props.values.modelIds;

    const ComposedComponent = useMemo(
      () =>
        withOptions(Component, {
          dispatchFn: getEcusByModel,
          mapper: mapAttendedECUToItemLabelModel,
          thunkArgs: {
            modelIds,
          },
        }),
      [modelIds]
    );

    return <ComposedComponent {...props} />;
  };
};
